import './global';
import '../css/rule.css';



// WEBPACK FOOTER //
// ./mobile/src/router/rule.js